import Clickable from 'components/Common/Clickable'
import ModalContext from 'contexts/ModalContext'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getLoyaltyDisplayTier from 'loyalty/selectors/getLoyaltyDisplayTier'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import React, { MouseEventHandler, useCallback, useContext } from 'react'
import LoyaltyStayUpgradeBenefitModal from './LoyaltyStayUpgradeBenefitModal'
import LoyaltyTierBenefitMessageBanner from './LoyaltyTierBenefitMessageBanner'
import styled from 'styled-components'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import OfferUrlContext from 'contexts/OfferUrlContext'

const ClickableContainer = styled(Clickable)`
  display: contents;
`

interface Props {
  offer: App.HotelOffer | App.HotelOfferSummary
  upgradeNotAvailableForSelectedDates?: boolean
}

function LoyaltyStayUpgradeBenefitMessageBanner({ offer, upgradeNotAvailableForSelectedDates = false }: Props) {
  const tier = useAppSelector(getLoyaltyDisplayTier)
  const showModal = useContext(ModalContext)
  const offerUrl = useContext(OfferUrlContext)

  const showRoomUpgradesModal = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    event.preventDefault()
    showModal(<LoyaltyStayUpgradeBenefitModal offer={offer} offerUrl={offerUrl} />)
  }, [showModal, offer, offerUrl])

  return <ClickableContainer onClick={showRoomUpgradesModal}>
    <LoyaltyTierBenefitMessageBanner
      tier={tier}
      benefitType="hotel_upgrade"
      endContent={<LineInfoCircleIcon />}
      density="compact"
    >
      {
        !upgradeNotAvailableForSelectedDates &&
        <>
          <CSSBreakpoint max="tablet">
            Free upgrade with your {getLoyaltyTierDisplayName(tier)} status
          </CSSBreakpoint>
          <CSSBreakpoint min="desktop">
            Enjoy a free upgrade with your {getLoyaltyTierDisplayName(tier)} {getLoyaltyProgramDisplayName()} status
          </CSSBreakpoint>
        </>
      }
      {
        upgradeNotAvailableForSelectedDates &&
        <>Upgrades unavailable on selected dates</>
      }
    </LoyaltyTierBenefitMessageBanner>
  </ClickableContainer>
}

export default withMountGuard(() => {
  return useAppSelector(getIsLoyaltyEnabled)
})(LoyaltyStayUpgradeBenefitMessageBanner)
